<ng-container *ngIf="!!params">
    <tt-button-goto
        *ngIf="params.show_checkin === '1'"
        ttText="workdetails_checkin"
        [ttBadge]="params.nbr_of_checkedin"
        ttGoto="checkinmenu"
        [ttGotoParms]="{ argtype: 'custact_no', argvalue: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_button_timeregister === '1'"
        ttText="register_hours"
        ttGoto="timeregister"
        [ttGotoParms]="{ custact_no: params.custact_no, powtime_keyno: '0' }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_button_materialregister_hour === '1'"
        ttText="workdetails_materialregister_hour"
        ttGoto="materialregister"
        [ttGotoParms]="{ custact_no: params.custact_no, powtime_keyno: '0', pkey: '-', materialtype: 'H' }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_button_materialregister === '1'"
        ttText="register_materials"
        ttGoto="materialregister"
        [ttGotoParms]="{ custact_no: params.custact_no, powtime_keyno: '0', pkey: '-', materialtype: 'M' }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_travelbills === '1'"
        ttText="workdetails_travelbills"
        [ttBadge]="params.nbr_of_travelbills"
        ttGoto="travelbills"
        [ttGotoParms]="{ argtype: 'custact_no', argvalue: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_comments === '1'"
        ttText="custact_dialog"
        [ttBadge]="params.nbr_of_custactdialogs"
        ttGoto="custactdialogs"
        [ttGotoParms]="{ custact_no: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_button_orders === '1'"
        ttText="quotation_and_orders"
        [ttBadge]="params.nbr_of_orders"
        ttGoto="orderheads"
        [ttGotoParms]="{ argtype: 'custact_no', argvalue: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_button_deviation === '1'"
        ttText="deviations"
        [ttBadge]="params.nbr_of_deviations"
        ttGoto="deviations"
        [ttGotoParms]="{ argtype: 'custact_no', argvalue: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto *ngIf="params.show_button_deviation === '1'" ttText="workdetails_custactcomplaint" ttGoto="custactcomplaint" [ttGotoParms]="{ custact_no: params.custact_no }"></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_button_forms === '1'"
        ttText="forms"
        [ttBadge]="params.nbr_of_checklistdata"
        ttGoto="checklistdatas"
        [ttGotoParms]="{ argtype: 'custact_no', argvalue: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto *ngIf="params.show_riskelements === '1'" ttText="risk_analysis" ttGoto="riskelements" [ttGotoParms]="{ argtype: 'custact_no', argvalue: params.custact_no }"></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_button_pictures === '1'"
        ttText="pictures"
        [ttBadge]="params.nbr_of_pictures"
        ttGoto="pictures"
        [ttGotoParms]="{ argtype: 'custact_no', argvalue: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_button_documents === '1'"
        ttText="documents"
        [ttBadge]="params.nbr_of_documents"
        ttGoto="documents"
        [ttGotoParms]="{ argtype: 'custact_no', argvalue: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_prepaymentinfo === '1'"
        ttText="prepayments"
        [ttBadge]="params.prepayments_badgeinfo"
        ttGoto="prepayments"
        [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: params.order_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.edit_custact_possible === '1'"
        ttText="edit_activity"
        ttGoto="custactedit"
        [ttGotoParms]="{ custact_no: params.custact_no, filterfield: '-', filtervalue: '-' }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_possibleprocesses === '1' && +params.project_keyno > 0"
        ttText="workdetails_possibleprocesses"
        [ttBadge]="params.nbr_of_custactprocess"
        ttGoto="custactprocess"
        [ttGotoParms]="{ custact_no: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto *ngIf="params.show_button_map === '1'" ttText="workdetails_mapview" ttGoto="mapview" [ttGotoParms]="{ argtype: 'custact_no', argvalue: params.custact_no }"></tt-button-goto>
    <tt-button-goto *ngIf="params.show_button_map3d === '1'" ttText="workdetails_map3d" ttGoto="mapview3d" [ttGotoParms]="{ argtype: 'custact_no', argvalue: params.custact_no }"></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_button_map3d === '1'"
        ttText="workdetails_uploadGpxFile"
        ttGoto="gpximport"
        [ttGotoParms]="{ argtype: 'custact_no', argvalue: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_send_email === '1'"
        ttText="workdetails_send_mail"
        ttGoto="emailcreate"
        [ttGotoParms]="{ webpage: 'workdetails', argtype: 'custact_no', argvalue: params.custact_no }"
    ></tt-button-goto>
    <tt-button-goto
        ttText="workdetails_print"
        ttIcon="fas fa-print"
        ttType="primary"
        ttTextAlign="center"
        ttIconAlign="right"
        ttGoto="selectreport"
        [ttGotoParms]="{ webpage_name: 'workdetails', argtype: 'custact_no', argvalue: params.custact_no }"
    ></tt-button-goto>
    <tt-button *ngIf="params.show_button_enable_delete === '1'" ttText="delete" ttIcon="fas fa-trash" ttType="danger" (ttClick)="deleteCustact()" [ttLoading]="deleting"></tt-button>
</ng-container>
